import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web-tms/src/app/[locale]/(auth)/layout-chakra.tsx");
